import { makeHook } from "../../utils/makeSingleArgHook";
import postAdvisorMarketplaceOfferingsQuery, { advisorMarketplaceOfferingsQueryUrl, } from "../requests/postAdvisorMarketplaceOfferingsQuery";
export function advisorMarketplaceOfferingsKeyMaker(bodyParams) {
    return [advisorMarketplaceOfferingsQueryUrl(), JSON.stringify(bodyParams)];
}
const useAdvisorMarketplaceOfferingsQuery = makeHook(async (bodyParams, auth) => postAdvisorMarketplaceOfferingsQuery(auth, bodyParams), (bodyParams) => advisorMarketplaceOfferingsKeyMaker(bodyParams));
export default useAdvisorMarketplaceOfferingsQuery;
//# sourceMappingURL=useAdvisorMarketplaceOfferingsQuery.js.map